import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.white,
  h1Color: colors.slateGrey,
  h2Color: colors.slateGrey,
  paraColor: colors.slateGrey,
  anchorColor: colors.neonPurple
};
export default richText;